export const menuPoint = "md";